import * as React from 'react';
import styles from './index.less';

import img_audio from '@/assets/audio.png';
import img_general from '@/assets/general.png';
import img_image from '@/assets/image.png';
import img_pdf from '@/assets/pdf.png';
import img_txt from '@/assets/txt.png';
import img_video from '@/assets/video.png';
import img_zip from '@/assets/zip.png';
import img_cartoon from '@/assets/cartoon.png';
import { FUtil } from '@freelog/tools-lib';

interface FFileTypeIconProps {
  style?: React.CSSProperties;
  className?: string;
  mime: string;
}

function FFileTypeIcon({ style, className, mime }: FFileTypeIconProps) {
  const [$img, set$img, get$img] = FUtil.Hook.useGetState<string>(img_general);

  React.useEffect(() => {
    if (mime.startsWith('text/')) {
      set$img(img_txt);
    }

    if (mime.startsWith('audio/')) {
      set$img(img_audio);
    }

    if (mime.startsWith('video/')) {
      set$img(img_video);
    }

    if (mime.startsWith('image/')) {
      set$img(img_image);
    }

    if (
      [
        'application/gzip',
        'application/x-gzip',
        'application/zip',
        'application/rar',
        'application/vnd.rar',
        'application/tar',
        'application/x-tar',
      ].includes(mime)
    ) {
      set$img(img_zip);
    }

    if (mime.startsWith('application/pdf')) {
      set$img(img_pdf);
    }

    if (mime === 'application/vnd.freelog.comic') {
      set$img(img_cartoon);
    }
  }, [mime]);

  return <img src={$img} alt={''} style={{ width: 36, ...style }} className={className} />;
}

export default FFileTypeIcon;
